import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { IntroSection } from './components/IntroSection';
import { FeatureSection } from './components/FeatureSection';
import { MechanismSection } from './components/MechanismSection';
import { WeeklyBreakdownSection } from './components/WeeklyBreakdownSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ImageSection } from './components/ImageSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ValueStackSection } from './components/ValueStackSection';
import { ComparisonSection } from './components/ComparisonSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FounderQuoteSection } from './components/FounderQuoteSection';
import { GuidesSection } from './components/GuidesSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { CTASection } from './components/CTASection';
import { FAQSection } from './components/FAQSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="w-full min-h-screen bg-teal-900 text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ImageSection data-id="element-4" />
        <IntroSection data-id="element-5" />
        <FeatureSection data-id="element-6" />
        <MechanismSection data-id="element-7" />
        <WeeklyBreakdownSection data-id="element-8" />
        <BenefitsSection data-id="element-9" />
        <HowItWorksSection data-id="element-10" />
        <ValueStackSection data-id="element-11" />
        <ComparisonSection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <FounderQuoteSection data-id="element-14" />
        <GuidesSection data-id="element-15" />
        <GuaranteeSection data-id="element-16" />
        <CTASection data-id="element-17" />
        <FAQSection data-id="element-18" />
        <CTASection data-id="element-19" />
        <FooterSection data-id="element-20" />
      </main>
    </div>;
}